import axios from '../../utils/axios';

export default function addLGCollection(adminId, data) {
    return (
        axios.post(`/admin/${adminId}/lGCollection`,  data )
    )
}
